import parse from './parser';
import draw from './draw';
import misc from './misc';

class CSVGBlaster {
  constructor(svg, options) {
    // this.debug = options && !!options.debug;
    this.debug = false;
    this.parse(svg);
    return this;
  }
}

CSVGBlaster.prototype.parse = parse;
CSVGBlaster.prototype.draw = draw;

let keys = Object.keys(misc);

keys.forEach(function (key) {
  CSVGBlaster.prototype[key] = misc[key];
});

export default CSVGBlaster;
